/**
 * StatusMessage - Color-coded status message display for recommendations
 */
import React from 'react';

export type StatusType = 'success' | 'error' | 'info' | 'warning';

interface StatusMessageProps {
  type: StatusType;
  message: string;
  className?: string;
}

export function StatusMessage({ type, message, className = '' }: StatusMessageProps) {
  const baseClasses = 'p-3 rounded-md text-sm';

  const typeClasses = {
    success: 'bg-green-50 text-green-800 border border-green-200',
    error: 'bg-red-50 text-red-800 border border-red-200',
    info: 'bg-blue-50 text-blue-800 border border-blue-200',
    warning: 'bg-yellow-50 text-yellow-800 border border-yellow-200',
  };

  return (
    <div className={`${baseClasses} ${typeClasses[type]} ${className}`}>
      {message}
    </div>
  );
}
